import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Geist_Mono, Inter, Syne } from 'next/font/google'
import SiteNav from '@/components/generals/site-nav'

const sans = Inter({
    subsets: ['latin']
})

const heading = Syne({
    subsets: ['latin']
})

// nothing on the site is set in mono, so it is never preloaded
const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <SiteNav />

            <Component {...pageProps} />
        </div>
    )
}

export default App